module.exports = __webpack_public_path__ + "6da07f2d76002e98c37518e78dbdc162.pdf";